<template>
    <div class="section demo-section fade-in-section">
        <h2 class="section-title">Try It Yourself</h2>
        
        <DemoQuestionCard />

        <div class="demo-cta">
            <p>This is just the beginning</p>
            <router-link to="/register" class="btn btn-primary">
                Get Started Free
            </router-link>
        </div>
    </div>
</template>

<script>
import DemoQuestionCard from '@/components/home/DemoQuestionCard.vue';

export default {
    name: 'DemoSection',
    components: {
        DemoQuestionCard
    }
};
</script>

<style scoped>
.section {
    position: relative;
    z-index: 2;
    padding: 80px 20px;
    max-width: 80vw;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid var(--accent);
}

.section-title {
    font-size: 48px;
    text-align: center;
    margin-bottom: 60px;
    color: var(--text-primary);
}

.demo-section {
    background: transparent;
}

.demo-cta {
    margin-top: 30px;
    text-align: center;
}

.demo-cta p {
    color: var(--text-primary);
    font-size: 20px;
    margin-bottom: 20px;
}

.btn {
    padding: 15px 40px;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: transform 0.2s, box-shadow 0.2s;
    display: inline-block;
    border-radius: 1px;
}

.btn-primary {
    background: var(--text-primary);
    color: var(--bg-primary);
}

.btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.fade-in-section {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-section.is-visible {
    opacity: 1;
    transform: translateY(0);
}

@media (max-width: 768px) {
    .section-title {
        font-size: 36px;
    }
    
    .section {
        min-height: auto;
        padding: 60px 20px;
    }
}
</style>